import React, { useContext } from "react";

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

import Chip from "../../../../components/basics/Chip";

import { PrescricaoContext } from "../contexts/PrescricaoContext";
import usePrescricaoController from "../controllers/PrescricaoController";
import { HeaderAccordion, TableContent } from "../styles/Prescricao";

// falta tudo, selecioanar um produto Aro que irá compor a prescricao
// trara o valor cadastrado mas poderá ser alterado na prescrição

const AccordionPrescricaoCadastroAro = ({ ...props }) => {
  const { handleChangeOpenAcordion } = usePrescricaoController();
  const { expanded } = useContext(PrescricaoContext);

  return (
    <>
      <Grid item md={6} xs={12}>
        <Accordion expanded={expanded.registerFrame || false}>
          <AccordionSummary
            expandIcon={
              <ExpandMoreIcon
                onClick={() => handleChangeOpenAcordion("registerFrame")}
              />
            }
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            <HeaderAccordion>
              <Grid container spacing={1} alignItems="center">
                <Grid
                  item
                  xs
                  onClick={() => handleChangeOpenAcordion("registerFrame")}
                >
                  <Chip label="Aro" bgcolor={"default"} />
                </Grid>
              </Grid>
            </HeaderAccordion>
          </AccordionSummary>

          <AccordionDetails>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TableContent>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      aaaa
                    </Grid>
                  </Grid>
                </TableContent>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
      </Grid>
    </>
  );
};

export default AccordionPrescricaoCadastroAro;
